import Col from './Col'
import Container from './Container'
import Row from './Row'

export default { Col, Container, Row }
